<template>
  <div>
    <SysBtn @click="dialog_ativo = !dialog_ativo">
      <v-icon size="20">mdi-finance</v-icon>
      <span class="ml-1">Indicador de evolução</span>
    </SysBtn>


    <v-dialog v-model="dialog_ativo" fullscreen transition="dialog-bottom-transition" persistent>
      <v-card>
        <div id="titulo-dialog">
          <v-btn icon dark class="mr-4" @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div class="d-flex align-center">
            <span class="font-20">Análise Macro</span>
            <span class="font-14 pt-1 pl-1" style="color: #fcfcfc">- Indicador da evolução do estoque (R$ custo)</span>
          </div>
        </div>

        <v-card-text class="pb-0 mt-n3 px-0">
          <div class="d-flex align-center pt-3 px-2">
            <span class="font-20 font-weight-medium text-systock-blue pl-2">Evolução do estoque</span>

            <v-divider vertical class="mx-4" />

            <Filtros :size="3" @update:filtros="buscarDadosIndicador()">
              <template #append>
                <DivisorComLegenda legenda="Outros filtros" class="mt-3" />

                <div class="d-flex align-center mt-3">
                  <div class="w-50-porcento pl-1 pr-1">
                    <SysCompradorAutocomplete
                      v-model="filtros_indicador.compradores"
                      label="Compradores"
                      :qtde_visivel_selecionados="1"
                      :ids-segmento="filtros_indicador.segmentos"
                      outlined
                      multiple
                      hide-details
                      clearable
                    >
                      <template #selection="{item}">
                        <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros_indicador.compradores" :item="item" item_value="nome" />
                      </template>
                    </SysCompradorAutocomplete>
                  </div>

                  <div class="w-50-porcento pl-1 pr-1">
                    <SysSegmentoAutocomplete
                      v-model="filtros_indicador.segmentos"
                      label="Segmentos"
                      :qtde-visivel-selecionados="1"
                      outlined
                      multiple
                      hide-details
                      clearable
                    >
                      <template #selection="{item}">
                        <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros_indicador.segmentos" :item="item" />
                      </template>
                    </SysSegmentoAutocomplete>
                  </div>

                  <div class="w-50-porcento pl-1 pr-1">
                    <SysFornecedorAutocomplete
                      v-model="filtros_indicador.fornecedores"
                      label="Fornecedores"
                      :qtde-visivel-selecionados="1"
                      :ids-segmento="filtros_indicador.segmentos"
                      :ids-comprador="filtros_indicador.compradores"
                      outlined
                      multiple
                      hide-details
                      clearable
                    >
                      <template #selection="{item}">
                        <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros_indicador.fornecedores" :item="item" />
                      </template>
                    </SysFornecedorAutocomplete>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <div class="w-50-porcento pr-1 mt-3">
                    <SysStatusProduto v-model="filtros_indicador.status_produto" />
                  </div>

                  <div class="w-50-porcento px-1 mt-3 pr-1">
                    <SysAutocomplete
                      v-model="filtros_indicador.pedidos_pendentes"
                      label_props="Pedidos Pendentes"
                      :items_props="items_props_produtos_pendentes"
                    />
                  </div>

                  <div class="w-50-porcento mt-3 pl-1">
                    <SysProdutoAutocomplete
                      v-model="filtros_indicador.produtos"
                      label="Produtos"
                      :qtde_visivel_selecionados="1"
                      :fornecedores="filtros_indicador.fornecedores"
                      outlined
                      multiple
                      hide-details
                      clearable
                    >
                      <template #selection="{item}">
                        <TextoOutrosFiltrosSelecionadosAutocomplete
                          :filtros="filtros_indicador.produtos"
                          :item="item"
                          item_key="id_produto"
                          item_value="descricao"
                        />
                      </template>
                    </SysProdutoAutocomplete>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <div class="w-50-porcento pr-1 mt-3">
                    <SysMarcaAutocomplete
                      v-model="filtros_indicador.marcas"
                      label="Marcas"
                      :qtde-visivel-selecionados="1"
                      :ids-segmento="filtros_indicador.segmentos"
                      :ids-comprador="filtros_indicador.compradores"
                      outlined
                      multiple
                      hide-details
                      clearable
                    >
                      <template #selection="{item}">
                        <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="filtros_indicador.marcas" :item="item" />
                      </template>
                    </SysMarcaAutocomplete>
                  </div>

                  <div class="w-50-porcento px-1 mt-3 pr-1"></div>

                  <div class="w-50-porcento mt-3 pl-1"></div>
                </div>
              </template>
            </Filtros>

            <MovimentacaoEstoque ref="movimentacaoEstoqueRef" :size="2" :filtros_iniciais="filtros_indicador" indicador_evolucao />
          </div>

          <div class="justify-center d-flex align-center pt-2">
            <template v-for="(_, index) in dados_grafico">
              <div v-if="index !== 'referencias'" :key="index" class="d-flex align-center px-3 font-12">
                <div class="quadrado-17 mr-1 border-full" :style="{background: cores[index]}">&nbsp;</div>
                {{ nomes[index] }}
              </div>
            </template>
          </div>

          <Chart
            :dados="dados_grafico"
            class="mt-n5 w-full"
            style="height: calc(100vh - 270px)"
            @click:range-grafico="clickRangeGrafico"
          />

          <div style="padding: 0 27px 0 17px" class="mt-n1">
            <Grid
              :dados="dados_grafico"
              @click:celula="clickCelulaGrid"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {componentes} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/Componentes.js";
import {buscarIndicadorEvolucao} from "@/api/Diagnostico/CurvasCruzadas";
import {logout} from "@/helpers";
import {cores, nomes} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/InformacoesGrafico";
import {serie_padrao} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/SeriePadrao";
import {salvarPeriodoAnalise} from "@/api/Diagnostico/SlowNoMoving/IndicadorEvolucaoSlowNoMoving";

export default {
  name: "Index",
  components: componentes,
  data: () => ({
    dialog_ativo: false,
    cores,
    nomes,
    dados_grafico: {
      total_aumentar: [],
      diferenca: [],
      estoque_parametrizavel: [],
      total_estoque: [],
      total_reduzir: [],
      referencias: [],
    },
    filtros_indicador: {
      segmentos: [],
      compradores: [],
      marcas: [],
      fornecedores: [],
      produtos: [],
      status_produto: [],
      pedidos_pendentes: []
    },
    timeout_filtros_indicador: null,
    referencias_data_americana: [],
    items_props_produtos_pendentes: [
      { id: 1, descricao: '1. Produtos sem Pedido Pendente' },
      { id: 2, descricao: '2. Produtos com Pedido Pendente' },
    ]
  }),
  computed: {
    FILTROS_STORE() {
      return this.$store.getters['filtrosProdutosDiagnostico/filtros_formato_api'];
    }
  },
  watch: {
    dialog_ativo() {
      if (this.dialog_ativo) {
        this.filtros_indicador = { ...this.FILTROS_STORE };
        this.buscarDadosIndicador();
      }
    },
    FILTROS_STORE() {
      if (this.dialog_ativo) {
        this.buscarDadosIndicador();
      }
    },
  },
  created() {
    this.resetarDados();
  },
  methods: {
    buscarDadosIndicador() {
      const parametros = {
        ...this.FILTROS_STORE,
        segmentos: this.filtros_indicador.segmentos,
        compradores: this.filtros_indicador.compradores,
        marcas: this.filtros_indicador.marcas,
        fornecedores: this.filtros_indicador.fornecedores,
        produtos: this.filtros_indicador.produtos,
        status_produto: this.filtros_indicador.status_produto,
        pedidos_pendentes: this.filtros_indicador.pedidos_pendentes
      };

      this.$store.dispatch('loading/addRequisicao',
        buscarIndicadorEvolucao(parametros)
          .then(resultado => {
            this.dados_grafico = resultado.indicador;
            this.referencias_data_americana = resultado.referencias_data_americana;
          })
          .catch(logout)
      );
    },
    resetarDados() {
      this.dados_grafico.total_aumentar = serie_padrao;
      this.dados_grafico.diferenca = serie_padrao;
      this.dados_grafico.estoque_parametrizavel = serie_padrao;
      this.dados_grafico.total_estoque = serie_padrao;
      this.dados_grafico.total_reduzir = serie_padrao;
    },
    clickRangeGrafico({ config }) {
      if (parseInt(config.seriesIndex) === 0) {
        const parametros = this.buscarDatasParaComparacao(config.dataPointIndex);
        this.salvarPeriodoAnaliseSlowNoMoving(parametros);
      }
    },
    clickCelulaGrid({ index_linha, index_coluna }) {
      if (index_linha === 'total_reduzir') {
        const parametros = this.buscarDatasParaComparacao(index_coluna);
        this.salvarPeriodoAnaliseSlowNoMoving(parametros);
      }
    },
    buscarDatasParaComparacao(index_referencia) {
      const formatarData = (data) => {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
      };

      let data_inicial = (index_referencia > 0)
        ? new Date(this.referencias_data_americana[index_referencia - 1])
        : new Date(this.referencias_data_americana[index_referencia]);

      let data_final = (index_referencia > 0)
        ? this.referencias_data_americana[index_referencia]
        : this.referencias_data_americana[index_referencia + 1];

      if (index_referencia === 0) {
        data_inicial.setDate(data_inicial.getDate() - 7);
        data_final = this.referencias_data_americana[index_referencia];
      }

      return {
        data_inicial: formatarData(data_inicial),
        data_final
      };
    },
    salvarPeriodoAnaliseSlowNoMoving(parametros) {
      this.$store.dispatch("loading/addRequisicao",
        salvarPeriodoAnalise(parametros)
          .then(() => this.$refs.movimentacaoEstoqueRef.dialog_ativo = true)
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
#titulo-dialog {
  height: 60px;
  background: #042333;
  color: white;
  display: flex;
  align-items: center;
}

#tabela-valores tr td {
  border-top: 1px solid #e7e3e3;
  border-bottom: 1px solid #e7e3e3;
  font-size: 12px;
  padding: 2px 0;
}

.border-full {
  border: 1px solid #939292;
}
</style>
